import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: {
		inDeadline: 0,
		nearingDeadline: 0,
		afterDeadline: 0,
		newTasks: 0,
		newInformation: 0,
		informationTotal: 0,
	},
};

export const dashboardTasksAndInformation = createSlice({
	name: 'dashboard-tasksAndInformation',
	initialState,
	reducers: {
		setTasksAndInformation: (state, { payload }) => ({
			...state,
			data: payload,
		}),
		reset: () => initialState,
	},
});

export default dashboardTasksAndInformation.reducer;
export const REDUCER_NAME = dashboardTasksAndInformation.name;

export const { setTasksAndInformation, reset } = dashboardTasksAndInformation.actions;
